"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.platformImpersonations = exports.accountOrigins = exports.breakGlassEvents = exports.minimumNecessaryDeclarations = exports.personTenantAffiliations = exports.people = exports.practiceConfigurations = exports.practices = exports.servicePrincipals = exports.recordAccessEvents = exports.roleAssignments = exports.tenants = void 0;
// The foundation subset of docs/rpm/03-RPM-SCHEMA.md §7.3 — bound to the tenancy specification's
// columns (N4), declared here rather than left to §4 prose (RPM-CR-35). §7 is the register that
// wins (§1.1), so where §7.3 and the tenancy specification differ, §7.3 is what is built and the
// difference is recorded as a decision.
//
// What differs from TENANCY §6.2/§6.4 and nothing else does: `user_account_id` -> `user_id` keyed
// to Better Auth `user.id` (CR-33); `certified_facility_id uuid` -> `facility_id varchar(20)`
// (CR-31); `patient_id uuid` -> `patient_id varchar(20)` on `record_access_events` and
// `break_glass_events` (CR-23, CR-31, the patient is carease.patients.id and there is no ChartVN
// patient master to hold a uuid); and `practices.primary_billing_entity_id` is not carried, because
// a foreign key to a table this domain does not build is a defect rather than a column.
const pg_core_1 = require("drizzle-orm/pg-core");
const drizzle_orm_1 = require("drizzle-orm");
const schema_1 = require("./schema"); // Better Auth — never modified (N17)
const e = __importStar(require("./rpm-enums"));
exports.tenants = (0, pg_core_1.pgTable)("tenants", {
    tenantId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantSlug: (0, pg_core_1.text)().notNull(),
    legalName: (0, pg_core_1.text)().notNull(),
    status: e.tenantStatus().notNull(),
    defaultTimeZone: (0, pg_core_1.text)().notNull(), // fallback only; the operative zone is the facility's
    dataResidencyRegion: (0, pg_core_1.text)(),
    validFrom: (0, pg_core_1.date)().notNull(),
    validTo: (0, pg_core_1.date)(),
    recordedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
}, (t) => [
    (0, pg_core_1.uniqueIndex)("uq_tenant_slug").on(t.tenantSlug),
    // TENANCY's line 2652 declares this and §7.3 dropped it in transcription. It is added by
    // 0018_tenant_period.sql rather than by a generated migration, because the table is already
    // deployed (D-282, J-138).
    (0, pg_core_1.check)("tenant_period", (0, drizzle_orm_1.sql) `${t.validTo} IS NULL OR ${t.validTo} > ${t.validFrom}`),
]);
/* role_assignments — three changes (§4.1.1) */
exports.roleAssignments = (0, pg_core_1.pgTable)("role_assignments", {
    roleAssignmentId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)().references(() => exports.tenants.tenantId), // NULLABLE: a PLATFORM row has none
    userId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id), // was user_account_id — CR-33
    roleCode: e.roleCode().notNull(), // 15 values — CR-12
    scopeKind: e.accessScopeKind().notNull(), // +PLATFORM — CR-12
    scopeId: (0, pg_core_1.uuid)(), // practice / org unit
    scopeFacilityId: (0, pg_core_1.varchar)({ length: 20 }), // mirror facility — CR-31
    grantedByUserId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    validFrom: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    validTo: (0, pg_core_1.timestamp)({ withTimezone: true }),
    recordedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    supersededAt: (0, pg_core_1.timestamp)({ withTimezone: true }),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    updatedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    updatedBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    (0, pg_core_1.index)("ix_role_assignment_current").on(t.tenantId, t.userId, t.validFrom),
    (0, pg_core_1.check)("ra_period", (0, drizzle_orm_1.sql) `${t.validTo} IS NULL OR ${t.validTo} > ${t.validFrom}`),
    // exactly one scope key, matching the kind; PLATFORM and TENANT carry neither
    (0, pg_core_1.check)("ra_scope_shape", (0, drizzle_orm_1.sql) `
    (${t.scopeKind} IN ('TENANT','PLATFORM') AND ${t.scopeId} IS NULL AND ${t.scopeFacilityId} IS NULL)
 OR (${t.scopeKind} = 'CERTIFIED_FACILITY'  AND ${t.scopeId} IS NULL AND ${t.scopeFacilityId} IS NOT NULL)
 OR (${t.scopeKind} IN ('ORG_UNIT','PRACTICE','BUILDING') AND ${t.scopeId} IS NOT NULL AND ${t.scopeFacilityId} IS NULL)`),
    // a PLATFORM assignment is the only tenant-less one — CR-12
    (0, pg_core_1.check)("ra_platform_tenantless", (0, drizzle_orm_1.sql) `(${t.scopeKind} = 'PLATFORM') = (${t.tenantId} IS NULL)`),
    // separation of duties: no self-grant — CR-12
    (0, pg_core_1.check)("ra_no_self_grant", (0, drizzle_orm_1.sql) `${t.grantedByUserId} <> ${t.userId}`),
]);
/* record_access_events — two changes (§4.1.2). The volume table: reads dominate. */
exports.recordAccessEvents = (0, pg_core_1.pgTable)("record_access_events", {
    recordAccessEventId: (0, pg_core_1.bigint)({ mode: "number" }).primaryKey().generatedByDefaultAsIdentity(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => exports.tenants.tenantId),
    accessedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    userId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    roleCode: e.roleCode().notNull(), // the role RELIED ON, not the reader's current role
    patientId: (0, pg_core_1.varchar)({ length: 20 }).notNull(), // carease.patients.id — §4.3.3, CR-23
    accessAction: e.accessAction().notNull(),
    accessBasis: e.accessBasis().notNull(), // +RPM_ALERT_ASSIGNMENT — CR-32
    breakGlassEventId: (0, pg_core_1.uuid)(),
    facilityId: (0, pg_core_1.varchar)({ length: 20 }), // the mirror facility, no FK — CR-31
    purposeOfUse: e.purposeOfUse().notNull(),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    (0, pg_core_1.index)("ix_rae_patient_time").on(t.tenantId, t.patientId, t.accessedAt),
    (0, pg_core_1.index)("ix_rae_actor_time").on(t.tenantId, t.userId, t.accessedAt),
    (0, pg_core_1.check)("rae_break_glass_linked", (0, drizzle_orm_1.sql) `
    (${t.accessBasis} = 'BREAK_GLASS') = (${t.breakGlassEventId} IS NOT NULL)`),
]);
/* service_principals — §4.1.5 */
exports.servicePrincipals = (0, pg_core_1.pgTable)("service_principals", {
    servicePrincipalId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)().references(() => exports.tenants.tenantId), // nullable: platform-level principals
    userId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    principalKind: e.principalKind().notNull(),
    accountablePersonId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => exports.people.personId),
    description: (0, pg_core_1.text)().notNull(),
    validFrom: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    validTo: (0, pg_core_1.timestamp)({ withTimezone: true }),
    recordedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    supersededAt: (0, pg_core_1.timestamp)({ withTimezone: true }),
    createdBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    updatedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    updatedBy: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
}, (t) => [
    (0, pg_core_1.uniqueIndex)("uq_service_principal_user").on(t.userId),
    // Every effective-dated table in this schema refuses a period that ends at or before it
    // starts; ten of the fourteen said so and these four did not (D-286, J-139).
    (0, pg_core_1.check)("sp_period", (0, drizzle_orm_1.sql) `${t.validTo} IS NULL OR ${t.validTo} > ${t.validFrom}`),
]);
exports.practices = (0, pg_core_1.pgTable)("practices", {
    practiceId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => exports.tenants.tenantId),
    practiceCode: (0, pg_core_1.text)().notNull(),
    practiceName: (0, pg_core_1.text)().notNull(),
    practiceKind: e.practiceKind(),
    parentPracticeId: (0, pg_core_1.uuid)().references(() => exports.practices.practiceId),
    // primary_billing_entity_id is NOT carried: it would be a foreign key to a billing_entity
    // table this domain does not build, which is a defect rather than a column.
    validFrom: (0, pg_core_1.date)().notNull(),
    validTo: (0, pg_core_1.date)(),
    recordedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    supersededAt: (0, pg_core_1.timestamp)({ withTimezone: true }),
}, (t) => [
    (0, pg_core_1.uniqueIndex)("uq_practice_code")
        .on(t.tenantId, t.practiceCode)
        .where((0, drizzle_orm_1.sql) `superseded_at IS NULL`),
    (0, pg_core_1.check)("practice_period", (0, drizzle_orm_1.sql) `${t.validTo} IS NULL OR ${t.validTo} > ${t.validFrom}`),
    (0, pg_core_1.check)("practice_not_self", (0, drizzle_orm_1.sql) `${t.parentPracticeId} IS DISTINCT FROM ${t.practiceId}`),
]);
/* practice_configurations — no change (§4.1.3). §4.5 states which RPM settings are keys here and
   which need first-class tables. */
exports.practiceConfigurations = (0, pg_core_1.pgTable)("practice_configurations", {
    id: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => exports.tenants.tenantId),
    scopeKind: e.configScopeKind().notNull(),
    scopeId: (0, pg_core_1.uuid)(),
    configKey: (0, pg_core_1.text)().notNull(),
    configValue: (0, pg_core_1.jsonb)().notNull(),
    isLocked: (0, pg_core_1.boolean)().notNull().default(false),
    validFrom: (0, pg_core_1.date)().notNull(),
    validTo: (0, pg_core_1.date)(),
    recordedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    supersededAt: (0, pg_core_1.timestamp)({ withTimezone: true }),
}, (t) => [
    // TENANCY's uq_cfg verbatim: the coalesce is what makes a TENANT-scoped row (scope_id NULL)
    // collide with another TENANT-scoped row for the same key, which a plain unique index would not.
    (0, pg_core_1.uniqueIndex)("uq_cfg")
        .on(t.tenantId, t.scopeKind, (0, drizzle_orm_1.sql) `coalesce(${t.scopeId}, '00000000-0000-0000-0000-000000000000'::uuid)`, t.configKey, t.validFrom)
        .where((0, drizzle_orm_1.sql) `superseded_at IS NULL`),
    (0, pg_core_1.check)("cfg_period", (0, drizzle_orm_1.sql) `${t.validTo} IS NULL OR ${t.validTo} > ${t.validFrom}`),
    (0, pg_core_1.check)("cfg_scope_id", (0, drizzle_orm_1.sql) `
    (${t.scopeKind} =  'TENANT' AND ${t.scopeId} IS NULL)
 OR (${t.scopeKind} <> 'TENANT' AND ${t.scopeId} IS NOT NULL)`),
]);
/* person is NOT tenant-scoped: one human may work for two customers (§2.3). Its tenant reach is
   person_tenant_affiliations, and its treatment follows the shared reference data: not scoped to a
   customer. */
exports.people = (0, pg_core_1.pgTable)("people", {
    personId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    familyName: (0, pg_core_1.text)().notNull(),
    givenName: (0, pg_core_1.text)().notNull(),
    middleName: (0, pg_core_1.text)(),
    nameSuffix: (0, pg_core_1.text)(),
    credentialSuffix: (0, pg_core_1.text)(),
    preferredName: (0, pg_core_1.text)(),
    birthDate: (0, pg_core_1.date)(),
    personStatus: e.personStatus().notNull().default("ACTIVE"),
    mergedIntoPersonId: (0, pg_core_1.uuid)().references(() => exports.people.personId),
    validFrom: (0, pg_core_1.date)().notNull(),
    validTo: (0, pg_core_1.date)(),
    recordedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    supersededAt: (0, pg_core_1.timestamp)({ withTimezone: true }),
}, (t) => [
    (0, pg_core_1.check)("person_period", (0, drizzle_orm_1.sql) `${t.validTo} IS NULL OR ${t.validTo} > ${t.validFrom}`),
    (0, pg_core_1.check)("person_merge_target", (0, drizzle_orm_1.sql) `
    (${t.personStatus} = 'MERGED_AWAY') = (${t.mergedIntoPersonId} IS NOT NULL)`),
    (0, pg_core_1.check)("person_not_self_merge", (0, drizzle_orm_1.sql) `${t.mergedIntoPersonId} IS DISTINCT FROM ${t.personId}`),
]);
exports.personTenantAffiliations = (0, pg_core_1.pgTable)("person_tenant_affiliations", {
    personTenantAffiliationId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => exports.tenants.tenantId),
    personId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => exports.people.personId),
    displayName: (0, pg_core_1.text)(),
    affiliationStatus: e.affiliationStatus().notNull().default("PENDING"),
    firstActiveOn: (0, pg_core_1.date)(),
    validFrom: (0, pg_core_1.date)().notNull(),
    validTo: (0, pg_core_1.date)(),
    recordedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    supersededAt: (0, pg_core_1.timestamp)({ withTimezone: true }),
}, (t) => [
    (0, pg_core_1.index)("ix_pta_person").on(t.personId, t.tenantId),
    (0, pg_core_1.check)("pta_period", (0, drizzle_orm_1.sql) `${t.validTo} IS NULL OR ${t.validTo} > ${t.validFrom}`),
    // TENANCY's pta_no_overlap is an EXCLUDE USING gist constraint, which Drizzle cannot declare
    // (§7.7(g)). It is not dropped — it is raw SQL, like the triggers.
]);
exports.minimumNecessaryDeclarations = (0, pg_core_1.pgTable)("minimum_necessary_declarations", {
    minimumNecessaryDeclarationId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => exports.tenants.tenantId),
    roleCode: e.roleCode().notNull(), // the same 15-code vocabulary — CR-33
    phiCategory: (0, pg_core_1.text)().notNull(),
    minimumNecessaryApplies: (0, pg_core_1.boolean)().notNull(),
    exceptionBasis: e.mnExceptionBasis(),
    limitationMethod: e.mnLimitationMethod(),
    criteriaRef: (0, pg_core_1.text)(),
    validFrom: (0, pg_core_1.date)().notNull(),
    validTo: (0, pg_core_1.date)(),
    recordedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    supersededAt: (0, pg_core_1.timestamp)({ withTimezone: true }),
}, (t) => [
    (0, pg_core_1.uniqueIndex)("uq_mnd")
        .on(t.tenantId, t.roleCode, t.phiCategory)
        .where((0, drizzle_orm_1.sql) `superseded_at IS NULL`),
    (0, pg_core_1.check)("mnd_period", (0, drizzle_orm_1.sql) `${t.validTo} IS NULL OR ${t.validTo} > ${t.validFrom}`),
    // 45 CFR 164.502(b)(2): where the standard does not apply, say which exception
    (0, pg_core_1.check)("mnd_exception", (0, drizzle_orm_1.sql) `${t.minimumNecessaryApplies} = (${t.exceptionBasis} IS NULL)`),
    (0, pg_core_1.check)("mnd_method", (0, drizzle_orm_1.sql) `NOT ${t.minimumNecessaryApplies} OR ${t.limitationMethod} IS NOT NULL`),
]);
exports.breakGlassEvents = (0, pg_core_1.pgTable)("break_glass_events", {
    breakGlassEventId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    tenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => exports.tenants.tenantId),
    userId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id), // was user_account_id — CR-33
    patientId: (0, pg_core_1.varchar)({ length: 20 }).notNull(), // carease.patients.id — CR-23, CR-31
    facilityId: (0, pg_core_1.varchar)({ length: 20 }), // CR-31
    invokedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    declaredReason: (0, pg_core_1.text)().notNull(),
    purposeOfUse: e.purposeOfUse().notNull(),
    normalAccessBasisAbsent: (0, pg_core_1.text)().notNull(),
    expiresAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull(),
    reviewRequired: (0, pg_core_1.boolean)().notNull().default(true),
    reviewedAt: (0, pg_core_1.timestamp)({ withTimezone: true }),
    reviewedByUserId: (0, pg_core_1.uuid)().references(() => schema_1.user.id),
    reviewOutcome: e.breakGlassOutcome(),
}, (t) => [
    (0, pg_core_1.index)("ix_bge_patient").on(t.tenantId, t.patientId, t.invokedAt),
    // 45 CFR 164.312(a)(2)(ii): emergency access is Required, and bounded
    (0, pg_core_1.check)("bge_expires", (0, drizzle_orm_1.sql) `${t.expiresAt} > ${t.invokedAt}`),
    (0, pg_core_1.check)("bge_always_reviewed", (0, drizzle_orm_1.sql) `${t.reviewRequired}`),
    (0, pg_core_1.check)("bge_review", (0, drizzle_orm_1.sql) `(${t.reviewedAt} IS NULL) = (${t.reviewOutcome} IS NULL)`),
    // the reviewer may not be the invoker
    (0, pg_core_1.check)("bge_reviewer", (0, drizzle_orm_1.sql) `${t.reviewedByUserId} IS DISTINCT FROM ${t.userId}`),
    (0, pg_core_1.check)("bge_reason_substantive", (0, drizzle_orm_1.sql) `length(btrim(${t.declaredReason})) >= 10`),
]);
/*
 * account_origins — the tenant an account was made for (J-695, `03-RPM-SCHEMA.md` §7.3). Better Auth's
 * `user` carries no tenant and is not modified (N17), so the record is a row of its own, written when
 * the account is made: by a tenant's administrator, for that tenant; by the platform operator, for the
 * new tenant whose first administrator it is (§10.4 step 3).
 *
 * THE RULE THAT TIES AN ACCOUNT TO A TENANT: an account belongs to the tenant this row names, and to
 * each tenant holding a current `role_assignments` row to it — and to no other tenant
 * (`apps/server/src/db/account-rule.ts`). An account made before this table has no row and none is
 * invented: it belongs by current grant only.
 */
exports.accountOrigins = (0, pg_core_1.pgTable)("account_origins", {
    // The origin goes with the account: removing an account its tenant made is not refused (D-1687).
    userId: (0, pg_core_1.uuid)()
        .primaryKey()
        .references(() => schema_1.user.id, { onDelete: "cascade" }),
    madeForTenantId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => exports.tenants.tenantId),
    madeByUserId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    madeAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
}, (t) => [
    (0, pg_core_1.index)("ix_account_origin_tenant").on(t.madeForTenantId),
    // an account is never its own maker
    (0, pg_core_1.check)("ao_not_self", (0, drizzle_orm_1.sql) `${t.madeByUserId} <> ${t.userId}`),
]);
/*
 * platform_impersonations — one row per impersonation a platform operator starts (`RPM-064`, J-690):
 * its stated reason in a column of its own, so the action log shows it with the start. Not in an
 * audit row's details, which are also printed to stdout (`.claude/rules/logging.md`), and not on
 * Better Auth's session row, which goes when the impersonation ends. The start's `audit_events` row
 * names this row by its id in `details.impersonationId`. Written once, never updated.
 */
exports.platformImpersonations = (0, pg_core_1.pgTable)("platform_impersonations", {
    platformImpersonationId: (0, pg_core_1.uuid)().primaryKey().defaultRandom(),
    operatorUserId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    impersonatedUserId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id),
    statedReason: (0, pg_core_1.text)().notNull(),
    startedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
    expiresAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull(),
}, (t) => [
    (0, pg_core_1.index)("ix_platform_impersonation_operator").on(t.operatorUserId, t.startedAt),
    (0, pg_core_1.check)("pi_reason_stated", (0, drizzle_orm_1.sql) `length(btrim(${t.statedReason})) > 0`),
    (0, pg_core_1.check)("pi_not_self", (0, drizzle_orm_1.sql) `${t.impersonatedUserId} <> ${t.operatorUserId}`),
    (0, pg_core_1.check)("pi_expires", (0, drizzle_orm_1.sql) `${t.expiresAt} > ${t.startedAt}`),
]);
//# sourceMappingURL=foundation.js.map